import {ServiceItem} from '../../../api/booking/types'

// A venue's `minPlayers` on a service was being ignored by the booking forms, which all
// initialised `minParticipants: 1`. The rest of WBA already honours the value — set-participants
// pads the list up to it and refuses to remove below it — so the minimum simply never arrived.
//
// This matters beyond validation: the price is derived from the participants array, so on a
// service with `multiplyPerPerson` the padded participants ARE the price floor. A 1,000/head
// service with `minPlayers: 10` bills 10,000 for anything up to ten people, which is how venues
// have been describing group privates all along.
//
// Classes are deliberately not covered: `minPlayers` lives on ServiceItem (`entity: 'service' |
// 'teacher'`) and class entities have no equivalent field.
export const resolveMinParticipants = (service?: ServiceItem | null): number => {
  const min = Number(service?.minPlayers)
  return Number.isFinite(min) && min > 1 ? Math.floor(min) : 1
}
